var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
export var WeightStationHeartbeatIndicator = function (_a) {
    var packageSeqId = _a.packageSeqId, lastWeightReceivedAt = _a.lastWeightReceivedAt, weightAgeSeconds = _a.weightAgeSeconds, weightPulseClass = _a.weightPulseClass, hasActiveSource = _a.hasActiveSource;
    var t = useTranslation().t;
    return (_jsxs("div", __assign({ className: '-mt-2 mb-2 flex items-center gap-2 text-xs text-gray-500' }, { children: [_jsx("span", { className: "inline-block h-2 w-2 rounded-full " + weightPulseClass }, void 0), _jsxs("span", { children: [t('Source'), ": ", t('Weighing Station'), packageSeqId ? " (Package #" + packageSeqId + ")" : '', ' • ', lastWeightReceivedAt
                        ? t('Last read') + " " + new Date(lastWeightReceivedAt).toLocaleTimeString() + " (" + weightAgeSeconds + "s)"
                        : hasActiveSource
                            ? t('Waiting for weight data')
                            : t('No active package selected for auto-weight')] }, void 0)] }), void 0));
};
export default WeightStationHeartbeatIndicator;
